import { Routes } from '@angular/router';

import { APP_ROUTES } from '@app/app-routes.const';
import { HomeGuard } from '@app/guards/home.guard';
import { AdminGuard } from '@app/guards/admin.guard';
import { NonAuthGuard } from './guards/non-auth.guard';
import { PartnerGuard } from '@app/guards/partner.guard';
import { LABELS_ROUTES } from '@app/pages/labels/labels.routes';

export const routes: Routes = [
  {
    path: APP_ROUTES.HOME,
    canActivate: [HomeGuard],
    loadChildren: () => import('./components/tabs/tabs.routes'),
  },
  {
    path: APP_ROUTES.LOGIN,
    canActivate: [NonAuthGuard],
    loadComponent: () => import('./pages/login/login.page').then((mod) => mod.LoginPage),
  },
  {
    path: APP_ROUTES.AUTH,
    canActivate: [NonAuthGuard],
    loadComponent: () => import('./pages/login/ms-login/ms-login.page').then((mod) => mod.MsLoginPage),
  },
  {
    path: APP_ROUTES.SETTINGS,
    canActivate: [PartnerGuard],
    loadComponent: () => import('./pages/settings/settings.page').then((m) => m.SettingsPage),
  },
  {
    path: APP_ROUTES.CONFERENCES,
    canActivate: [AdminGuard],
    loadComponent: () => import('./pages/conferences/conferences.page').then((m) => m.ConferencesPage),
  },
  {
    path: `${APP_ROUTES.DOWNLOAD}`,
    canActivate: [PartnerGuard],
    loadComponent: () => import('./pages/download/download.page').then((m) => m.DownloadPage),
  },
  {
    path: APP_ROUTES.LABELS,
    canActivate: [PartnerGuard],
    children: LABELS_ROUTES,
  },
  {
    path: APP_ROUTES.PIN_MANAGEMENT,
    canActivate: [AdminGuard],
    loadComponent: () => import('@app/pages/pin-management/pin-management.page').then((m) => m.PinManagementPage),
  },
  {
    path: 'tabs',
    redirectTo: APP_ROUTES.HOME,
  },
  {
    path: '',
    redirectTo: `/${APP_ROUTES.HOME}`,
    pathMatch: 'full',
  },
];
